module.exports = __webpack_public_path__ + "447cda55d4ce65eb1247bccbc9848aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/visitor/one/one-title.png
// module id = 1274
// module chunks = 0